import { NavLink, Outlet } from 'react-router-dom';

// Wrapper for the payment methods section — three internal tabs on
// top (delivery / electronic / banks). Each child renders a
// section-specific CRUD panel inside the Outlet.
export default function PaymentMethodsWrapperPage() {
  const tab = (to: string, label: string) => (
    <NavLink to={to} end className={({ isActive }) => `home-tab ${isActive ? 'active' : ''}`}>
      {label}
    </NavLink>
  );

  return (
    <>
      <div className="home-tabs" role="tablist" aria-label="أقسام طرق التبرع">
        {tab('/payment-methods/delivery', 'المناديب')}
        {tab('/payment-methods/electronic', 'الدفع الإلكتروني')}
        {tab('/payment-methods/banks', 'حسابات بنكية')}
      </div>
      <div className="home-tab-panel">
        <Outlet />
      </div>
    </>
  );
}
